<!--注册页-->
<template>
    <div>
        <div>
            <Card style="width:100%;">
<!--                <Cell title="注册公众号账号"/>-->
<!--                <Input v-model="value1" placeholder="请输入手机号码" style="width: 100%;padding: 10px 0px 10px 0px"/><br/>-->
<!--                <Input v-model="value2" placeholder="请输入验证码" style="width: 148px;padding: 10px 0px 10px 0px"/>-->
<!--                <Button type="info" style="width: 92px" :disabled="change" @click="getCode">-->
<!--                    {{change===true?'重新获取('+second+')':'获取验证码'}}-->
<!--                </Button>-->
<!--                <br/>-->
                <van-cell-group>
                <van-field label="注册公众号" readonly style="background-color: #9c9c9c"/>
                <van-field label="手机号码" v-model="value1" value="请输入手机号码" />
                <van-field
                        v-model="value2"
                        placeholder="验证码"
                        label="验证码"
                >
                    <van-button slot="button" type="info" size="small" @click="getCode">{{change===true?'重新获取('+second+')':'获取验证码'}}</van-button>
                </van-field>
                <Button size="large" style="width: 100%" type="success" @click="getRegister">注册</Button>
                </van-cell-group>
            </Card>

            <Card style="width:100%;">
                <van-field label="保险免费资格" readonly>
                    <van-button slot="button" type="info" size="small" to="../vehiclefreeinquire">查询</van-button>
                </van-field>
            </Card>
        </div>
        <div>

        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import store from '@/store'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
    } from 'vant'

    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);
    export default {
        name: "userRegister",
        data() {
            return {
                change: false,
                value1: '',
                value2: '',
                second: 30,
                status: false
            }
        },
        mounted() {

        },
        methods: {
            start() {
                var vm = this;
                if (vm.status) return;

                vm.status = true;
                vm.change = true
                var time = setInterval(() => {
                    var second = vm.second;
                    second--;
                    vm.second = second;

                    if (second == 0) {
                        clearInterval(time);
                        vm.second = 30
                        vm.status = false;
                        vm.change = false
                    }
                }, 1000);

            },
            getCode() {
                var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1})|(19[0-9]{1}))+\d{8})$/
                if (!this.value1 || this.value1 === '' || !myreg.test(this.value1)) {
                    this.$Message.error(
                        '请检查手机号码'
                    )
                    return;
                }
                //验证码
                store.dispatch('ClientAccountServ_GetRegisterSMSVerifyCode', {
                    params: {
                        telephone: this.value1
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    this.start()
                })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            getRegister() {
                //注册
                store.dispatch('AccountServ_RegisterByWechatServiceAccount', {
                    params: {
                        mobileVerifyCode: this.value2,
                        mobilePhoneNum: this.value1,
                        wechatServiceAccountOpenId: this.$root.openID,
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    if (res.code === 200) {
                        this.$router.push({
                            path: '/',
                        })
                    }
                })
                    .catch((err) => {
                        Toast(err)
                        console.log(err)
                    })
            },
        }
    }
</script>

<style scoped>

</style>
